import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import "../styles/LegalPages.css";

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <SEO
        title="Terms of Service - Grad4Grad"
        description="Read our Terms of Service to understand the terms and conditions for using Grad4Grad's study abroad guidance platform."
        keywords="terms of service, grad4grad terms, study abroad terms, legal terms"
        url="https://grad4grad.com/terms"
        type="website"
      />

      <div className="legal-container">
        <div className="legal-header">
          <h1>Terms of Service</h1>
          <p>Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="legal-content">
          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using Grad4Grad ("we," "our," or "us"), you
              accept and agree to be bound by the terms and provision of this
              agreement. If you do not agree to abide by the above, please do
              not use this service.
            </p>
          </section>

          <section>
            <h2>2. Description of Service</h2>
            <p>Grad4Grad is an educational guidance platform that provides:</p>
            <ul>
              <li>University search and comparison tools</li>
              <li>Study abroad guidance and counseling</li>
              <li>Scholarship information and resources</li>
              <li>Educational content and blog articles</li>
              <li>Admission process guidance</li>
            </ul>
          </section>

          <section>
            <h2>3. User Accounts and Registration</h2>
            <p>
              To access certain features of our service, you may be required to
              create an account. You agree to:
            </p>
            <ul>
              <li>Provide accurate, current, and complete information</li>
              <li>Maintain and update your account information</li>
              <li>Keep your account credentials secure</li>
              <li>
                Accept responsibility for all activities under your account
              </li>
            </ul>
          </section>

          <section>
            <h2>4. User Conduct</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use the service for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with or disrupt the service</li>
              <li>Share false or misleading information</li>
              <li>Violate any applicable laws or regulations</li>
            </ul>
          </section>

          <section>
            <h2>5. Privacy and Data Protection</h2>
            <p>
              Your privacy is important to us. Please review our{" "}
              <Link to="/privacy">Privacy Policy</Link>, which also governs your
              use of the service, to understand our practices.
            </p>
          </section>

          <section>
            <h2>6. Intellectual Property Rights</h2>
            <p>
              The service and its original content, features, and functionality
              are and will remain the exclusive property of Grad4Grad and its
              licensors. The service is protected by copyright, trademark, and
              other laws.
            </p>
          </section>

          <section>
            <h2>7. Disclaimers</h2>
            <p>
              The information provided on Grad4Grad is for educational purposes
              only. We do not guarantee:
            </p>
            <ul>
              <li>The accuracy of university information</li>
              <li>Admission to any educational institution</li>
              <li>Scholarship awards or financial aid</li>
              <li>Visa approval or immigration success</li>
            </ul>
            <p>
              Users should verify all information independently and consult with
              educational institutions directly.
            </p>
          </section>

          <section>
            <h2>8. Limitation of Liability</h2>
            <p>
              In no event shall Grad4Grad, nor its directors, employees,
              partners, agents, suppliers, or affiliates, be liable for any
              indirect, incidental, special, consequential, or punitive damages,
              including without limitation, loss of profits, data, use,
              goodwill, or other intangible losses, resulting from your use of
              the service.
            </p>
          </section>

          <section>
            <h2>9. Third-Party Links</h2>
            <p>
              Our service may contain links to third-party websites or services
              that are not owned or controlled by Grad4Grad. We have no control
              over, and assume no responsibility for, the content, privacy
              policies, or practices of any third-party websites or services.
            </p>
          </section>

          <section>
            <h2>10. Termination</h2>
            <p>
              We may terminate or suspend your account and bar access to the
              service immediately, without prior notice or liability, under our
              sole discretion, for any reason whatsoever and without limitation,
              including but not limited to a breach of the Terms.
            </p>
          </section>

          <section>
            <h2>11. Changes to Terms</h2>
            <p>
              We reserve the right, at our sole discretion, to modify or replace
              these Terms at any time. If a revision is material, we will
              provide at least 30 days notice prior to any new terms taking
              effect.
            </p>
          </section>

          <section>
            <h2>12. Governing Law</h2>
            <p>
              These Terms shall be interpreted and governed by the laws of
              India, without regard to its conflict of law provisions.
            </p>
          </section>

          <section>
            <h2>13. Contact Information</h2>
            <p>
              If you have any questions about these Terms of Service, please
              contact us at:
            </p>
            <ul>
              <li>Email: contact@grad4grad.com</li>
              <li>
                Website: <a href="https://grad4grad.com">grad4grad.com</a>
              </li>
            </ul>
          </section>
        </div>

        <div className="legal-footer">
          <Link to="/" className="back-link">
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
